import { Outlet } from "react-router-dom";
import PageLayout from "../../components/UI/Layout/PageLayout";

export default function ProfilesBailleurRootPage() {
  return (
    <PageLayout isBailleur>
      <Outlet />
    </PageLayout>
  );
}
